import { useContext } from 'react';
import { ChartConfigContext } from 'contexts/ChartConfigContext';

// ==============================|| CONFIG - HOOKS  ||============================== //

const useChartConfig = () => useContext(ChartConfigContext);

export default useChartConfig;
